import React, {
  useEffect,
  useState,
  useRef,
  InputHTMLAttributes,
  useCallback,
} from 'react';
import { useTranslation } from 'react-i18next';

import { Container } from './styles';

type handleInputsChange = (e: React.ChangeEvent<HTMLInputElement>) => void;

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  defaultValueChecked?: boolean;
  label?: string;
  isRow?: boolean;
  isChecked?: boolean;
  handleInputChange: handleInputsChange;
}

const SwitchButton: React.FC<InputProps> = ({
  name,
  defaultValueChecked,
  label,
  isRow,
  isChecked,
  handleInputChange,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [checked, setChecked] = useState<boolean>(!!defaultValueChecked);

  const { t } = useTranslation();

  const onChangeValue = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      handleInputChange(e);
      setChecked(e.target.checked);
    },
    [handleInputChange]
  );

  useEffect(() => {
    if (typeof isChecked === 'boolean') {
      setChecked(isChecked);
    }
  }, [isChecked]);

  return (
    <Container
      htmlFor={`${name}Id`}
      checked={checked}
      title={
        checked
          ? String(t('screens.registerProduct.marked'))
          : String(t('screens.registerProduct.unchecked'))
      }
      isRow={isRow}
      isDisabled={rest.disabled}
    >
      {label ? <div className="label">{label}</div> : null}
      <div className="switchButtonContainer">
        <div className="circle" />
        <div className="switch-content">
          <input
            id={`${name}Id`}
            type="checkbox"
            checked={checked}
            onChange={onChangeValue}
            name={name}
            ref={inputRef}
            {...rest}
          />
        </div>
      </div>
    </Container>
  );
};

export default SwitchButton;
